import { FC, useState, ReactNode } from 'react';
import { Icon } from 'common-components';
import Tooltip from '../tooltip';
import { useTranslationContext } from '../contexts/translationContext';
import styles from './leftSideExpandedPanel.module.scss';

const LeftSideExpandedPanel: FC<{
    children: ReactNode;
    onOpen: Function;
    top: string;
    onClose: Function;
    isOpen?: boolean;
}> = ({
    children,
    onOpen,
    onClose,
    top,
    isOpen = false
}: {
    children: ReactNode;
    onOpen: Function;
    onClose: Function;
    top: string;
    isOpen?: boolean;
}) => {
    const [left, setLeft] = useState<String>(isOpen ? '0' : '-17.625rem');
    const [isExpanded, setIsExpanded] = useState<boolean>(isOpen);
    const { translate } = useTranslationContext();

    const onUnExpand = () => {
        setLeft('-17.625rem');
        onClose();
        window.setTimeout(() => {
            setIsExpanded(false);
        }, 250);
    };

    const onExpand = () => {
        setIsExpanded(true);
        window.setTimeout(() => {
            setLeft('0');
            onOpen();
        }, 250);
    };

    return isExpanded ? (
        <div
            className={styles['left-side-panel']}
            style={{ '--left': left, '--top': top } as any}
            key={'left-side-panel'}
        >
            <div
                className={styles['svg-background']}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/expandBackground.svg)` }}
            />
            <div key="left-side-panel" className={styles['expand-button']} onClick={onUnExpand}>
                <Tooltip
                    key="left-side-panel-tooltip"
                    placement="right"
                    title={<div>{translate('CollapsePanel')}</div>}
                    enterDelay
                >
                    <div>
                        <Icon name="unExpand" key="unExpand" />
                    </div>
                </Tooltip>
            </div>

            {children}
        </div>
    ) : (
        <div
            className={styles['left-side-panel-un-expand']}
            key={'left-side-panel-un-expand'}
            style={{ '--top': top } as any}
        >
            <div
                className={styles['svg-background']}
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/expandBackground.svg)` }}
            />
            <Tooltip
                key="left-side-panel-un-expand-tooltip"
                placement="left"
                title={<div>{translate('ExpandPanel')}</div>}
                enterDelay
            >
                <div key="left-side-panel-un-expand" className={styles['expand-button']} onClick={onExpand}>
                    <Icon name="expand" key="expand" />
                </div>
            </Tooltip>
            {children}
        </div>
    );
};

export default LeftSideExpandedPanel;
